<template>
	<div :id="id" class="fixed top-0 left-0 w-screen h-screen bg-white/80 dark:bg-black/80 hidden justify-center items-start z-[1400] modal" @click="closeAllModals">
		<div :class="`w-screen h-dvh ${large ? 'lg:max-w-[90wv]' : 'lg:max-w-[36rem]'} lg:h-auto lg:max-h-dvh bg-gradient-to-br from-white to-gray-50 dark:from-gray-900 dark:to-gray-950 lg:rounded-lg flex flex-col lg:m-8 shadow-2xl shadow-gray-400 dark:shadow-black`" @click.stop="">
			<div class="flex items-center gap-3 px-5 py-3">
				<CloseButton @close="closeModal(id)"/>
				<div class="grow flex flex-col">
					<p class="text-2xl font-bold">
						<slot name="title"/>
					</p>
					<p class="text-gray-400">
						<slot name="subtitle"/>
					</p>
				</div>
				<slot name="footer"/>
			</div>
			<div :class="`${!tight ? 'px-6 py-5' : ''} flex flex-col gap-3 grow lg:max-h-[80dvh] overflow-y-auto`">
				<slot/>
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
import {defineProps} from 'vue'
import {closeAllModals, closeModal} from '@/helpers'
import CloseButton from '@/Components/Buttons/CloseButton.vue'

defineProps<{
	id:string,
	tight?:boolean,
	large?:boolean,
}>()
</script>